module.exports = __webpack_public_path__ + "static/media/template-small-grey.5563d9fa.svg";